/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_ALL_EVENTS } from "./actionTypes"
import { listAllEventsSuccess, listAllEventsError } from "./actions"

//Include Both Helper File with needed methods
import { getAllEvents } from "../../../helpers/backend_helper"

function* getAll(action) {
  try {
    const response = yield call(getAllEvents)
    if (response.statusCode) throw new Error(response.message)
    yield put(listAllEventsSuccess(response))
  } catch (error) {
    yield put(listAllEventsError(error))
  }
}

function* allEventsListSaga() {
  yield takeEvery(LIST_ALL_EVENTS, getAll)
}

export default allEventsListSaga
